module.exports = __webpack_public_path__ + "static/media/V8.3b88ba79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/V8.svg
// module id = 997
// module chunks = 0